/**
* @version GENERATOR_VERSION::20200408
* @DateTime 2020-04-22T09:43:57.985
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	listFinalInterview,
	listFinalInterviewInit,
	listFinalInterviewByAuthorizations,
	deleteFinalInterview
} from '@api/lcf/FinalInterview';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {	
		// 初始化信息
		CompoundEntitiesDictionary: cloneObj(RespCommonDef.CompoundEntitiesDictionary),
		//查询接口返回的数据
		CompoundEntities: cloneObj(RespCommonDef.CompoundEntities),
	    Entities:cloneObj(RespCommonDef.Entities),
		//查询条件
		AdvanceQuery:cloneObj(RespCommonDef.AdvanceQuery),
	},

	actions: {
		listFinalInterview({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinalInterview(state.AdvanceQuery)
					.then(async res => {
						state.Entities = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinalInterviewByAuthorizations({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinalInterviewByAuthorizations(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntities =res
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		listFinalInterviewInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				listFinalInterviewInit(state.AdvanceQuery)
					.then(async res => {
						state.CompoundEntitiesDictionary = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteFinalInterview({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteFinalInterview({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

	}
};
